import { breakpointsTailwind } from '@vueuse/core';

const useAppBreakpoints = () => {
  const { isMobile } = useDevice();
  const { greater } = useBreakpoints(breakpointsTailwind);

  return {
    isMobile,
    isTablet: greater('md'),
    isDesktop: greater('lg'),
    isLargeScreen: greater('2xl'),
  };
};

export default useAppBreakpoints;
